module.exports = __webpack_public_path__ + "af0cf0ce4af935442cebadd6e1e1b976.svg";